export const addAdditionalParams = (file: File, i: number) => {
    const extension = file.name.split(".").pop();
    const originalName = file.name.split(".").slice(0, -1).join(".");
    const random = Math.random().toString(36).substr(2, 4);
    const originalEncodedName = encodeURIComponent(originalName);
    const newName = `${originalEncodedName}_${random}.${extension}`;
    const newFile: any = new File([file], newName, { type: file.type });
    newFile.id = `${new Date().getTime()}-${i}`;
    newFile.percentage = 0;
    newFile.originalName = `${originalName}.${extension}`;
    newFile.originalEncodedName = originalEncodedName;
    return newFile;
};